export default {
  participants: 'Participants',
  host: '(Host)',
  removeParticipant: 'Remove participant',
  removeTitle: 'Remove participant',
  removeDescription: 'Remove {name} from this conference?',
  confirmButtonText: 'Remove',
  cancelButtonText: 'Cancel',
} as const;
